import React, {useEffect} from 'react';


import './Radio.scss';

export default function Radio({name, label, value, selectedValue, onChange}){
    const handleChange = () => {
        console.log(`RADIO HANDLER ${name}: `, name, value, selectedValue);
        onChange(value);
    }
    return (
        <label className="radioContainer">
            <input checked={selectedValue === value} type="radio" name={name} onChange={handleChange} />{label ? label : ''}
            <span className="check">
            </span>
        </label>
    )
}